import React from 'react';
import type { FitContext, FitStatus, FitVerdictData } from './types';

interface Props {
  verdict: FitVerdictData;
  context: FitContext;
}

/**
 * The status word is rendered as text, not conveyed by colour alone — the
 * pill is the first thing a rider reads and it has to survive a screenshot,
 * a colourblind reader and a greyscale print.
 */
const STATUS_WORD: Record<FitStatus, string> = {
  good: 'Looking good',
  warn: 'Borderline',
  bad: 'Needs a change',
  unknown: 'Partly measured',
};

const FitVerdict: React.FC<Props> = ({ verdict, context }) => (
  <section className="fr-verdict" aria-labelledby="fr-verdict-headline">
    <div className="fr-verdict__glow" aria-hidden="true" />

    <span className={`fr-pill fr-pill--${verdict.status}`}>
      <span className="fr-pill__dot" aria-hidden="true" />
      {STATUS_WORD[verdict.status]}
    </span>

    <h1 id="fr-verdict-headline" className="fr-verdict__headline">{verdict.headline}</h1>
    <p className="fr-verdict__summary">{verdict.summary}</p>

    <div className="fr-verdict__grid">
      {verdict.categories.map(c => (
        <div key={c.id} className={`fr-cell fr-cell--${c.status}`}>
          <div className="fr-cell__label">{c.label}</div>
          <div className="fr-cell__value">{c.value}</div>
        </div>
      ))}
    </div>

    <div className="fr-chips">
      <span className="fr-chip"><b>{context.bike}</b></span>
      <span className="fr-chip">Position <b>{context.position}</b></span>
      <span className="fr-chip">Experience <b>{context.experience}</b></span>
      <span className="fr-chip">Flexibility <b>{context.flexibility}</b></span>
      <span className="fr-chip">Reported issues <b>{context.issues}</b></span>
    </div>
  </section>
);

export default FitVerdict;
